import { render, staticRenderFns } from "./CardPaymentConfigIndex.vue?vue&type=template&id=10fc07f0"
import script from "./CardPaymentConfigIndex.vue?vue&type=script&lang=js"
export * from "./CardPaymentConfigIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports